import { useState, useEffect } from "react";

/**
 * Debounces spinner visibility for pending/loading states. The spinner becomes
 * visible only after the operation takes longer than `delayMs`, preventing
 * flickering for fast operations that complete within the threshold.
 */
export function usePendingState(isPending: boolean, delayMs = 500) {
  const [isProgressVisible, setIsProgressVisible] = useState(false);
  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout>;
    if (isPending) {
      timeout = setTimeout(() => setIsProgressVisible(true), delayMs);
    } else {
      setIsProgressVisible(false);
    }
    return () => clearTimeout(timeout);
  }, [isPending, delayMs]);
  return { isProgressVisible };
}
